// extracted by mini-css-extract-plugin
export default {"header":"Header_header__504Xs","main-image":"Header_main-image__mAxec"};